import intl from '../shared/intl';

export const selectors = {
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/not-found/index.js